module.exports = __webpack_public_path__ + "img/icon_4.1b247745.png";